<template>
        <v-card flat v-if="activecontact">
            <v-card-title>
                <CardCloser v-if="!editcontact"  @click="closeContact()" :loading="loading"/>
                <v-btn v-else color="warning" text class="pl-0 ml-3" @click.stop="cancelSave()" >
                    Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="!editcontact" :color="$store.state.color1" text  class="pa-0 ml-3"   @click="setEdit()">
                    <span>Edit</span>
                </v-btn>
                <v-btn v-else-if="dirty" text class="pa-0 ma-0"   color="warning" @click.stop="saveContact()" >
                    <span>Save</span>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-form v-model="valid" ref="form" >
                    <v-card-text>
                        <!--CONTACT INFO-->
                        <v-layout row wrap>
                            <v-flex xs9>
                                <v-text-field
                                   label="First Name, Last Name"
                                   v-model="contactinfo.name"
                                   :rules="[$store.state.rules.nameRules]"
                                   :disabled="!editcontact"
                                   :outlined="editcontact"
                                   :dense="editcontact"
                                   @keyup="setChange()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs3 class="text-center">
                                <v-menu offset-y class="pa-0 ma-0"  >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                                :disabled="!editcontact"
                                                outlined
                                                small
                                                v-on="on"
                                        >
                                            {{contactinfo.status}}
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                                v-for="s in contactstatus"
                                                :key="s"
                                                @click="contactinfo.status = s, setChange()"
                                        >
                                            <v-list-item-content>
                                                {{s}}
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                   label="Nickname"
                                   v-model="contactinfo.nickname"
                                   :rules="[$store.state.rules.nameRules]"
                                   :disabled="!editcontact"
                                   :outlined="editcontact"
                                   :dense="editcontact"
                                   @keyup="setChange()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm8 md8>
                                <v-text-field
                                        label="Cell"
                                        v-model="contactinfo.cell"
                                        clearable
                                        counter
                                        type="number"
                                        :rules="[$store.state.rules.cellRules]"
                                        :disabled="!editcontact"
                                        :outlined="editcontact"
                                        :dense="editcontact"
                                        @keyup="setChange()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs3 sm2 md2 class="text-right">
                                <a v-if="contactinfo.cell" :href="'tel:'+contactinfo.cell" style="text-decoration: none;"  >
                                    <v-btn small outlined fab>
                                        <v-icon>{{icons.call}}</v-icon>
                                    </v-btn>
                                </a>
                            </v-flex>
                            <v-flex xs3 sm2 md2 class="text-right">
                                <a v-if="contactinfo.cell" :href="'sms:'+contactinfo.cell" style="text-decoration: none;" >
                                    <v-btn  small outlined fab>
                                        <v-icon>{{icons.sms}}</v-icon>
                                    </v-btn>
                                </a>
                            </v-flex>
                            <v-flex xs8 sm10 md10 v-if="contactinfo.email">
                                <v-text-field
                                        label="E-mail"
                                        v-model="contactinfo.email"
                                        :rules="[$store.state.rules.emailRules]"
                                        :disabled="!editcontact"
                                        :outlined="editcontact"
                                        :dense="editcontact"
                                        @keyup="setChange()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm10 md10 v-else>
                                <v-text-field
                                        label="E-mail"
                                        v-model="contactinfo.email"
                                        :rules="[$store.state.rules.emailRules]"
                                        :disabled="!editcontact"
                                        :outlined="editcontact"
                                        :dense="editcontact"
                                        @keyup="setChange()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs4 sm2 md2 class="text-right">
                                <a v-if="contactinfo.email" :href="'mailto:'+contactinfo.email" style="text-decoration: none;" >
                                    <v-btn fab small outlined>
                                        <v-icon>{{icons.email}}</v-icon>
                                    </v-btn>
                                </a>
                            </v-flex>
                            <v-flex xs12 sm10>
                                <v-text-field
                                        label="Instagram"
                                        v-model="contactinfo.instagram"
                                        :disabled="!editcontact"
                                        :outlined="editcontact"
                                        :dense="editcontact"
                                        @keyup="setChange()"
                                ></v-text-field>
                            </v-flex>
                            <!--<v-flex xs12 sm10>-->
                                <!--<v-text-field-->
                                        <!--label="Custom Id"-->
                                        <!--v-model="contactinfo.customid"-->
                                        <!--:disabled="!editcontact"-->
                                        <!--:outlined="editcontact"-->
                                        <!--:dense="editcontact"-->
                                <!--&gt;</v-text-field>-->
                            <!--</v-flex>-->
                            <v-flex xs6>

                            </v-flex>
                            <v-flex xs6>

                            </v-flex>
                        </v-layout>

                        <!--CONTACT GROUPS-->
                        <v-layout row wrap>
                            <v-flex xs12>
                                <p class="heading">Groups</p>
                            </v-flex>
                            <v-flex xs6 v-if="1==1">
                                <v-btn text
                                       :disabled="!!editcontact"
                                       :loading="removing"
                                       v-if="!editcontactgroups"
                                       @click.stop="editcontactgroups = !editcontactgroups">
                                    remove
                                    <v-icon>{{$store.state.icons.ban}}</v-icon>
                                </v-btn>
                                <v-btn text  v-else @click.stop="editcontactgroups = !editcontactgroups" :loading="removing">
                                    done
                                    <v-icon>{{$store.state.icons.undo}}</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs6 v-else></v-flex>
                            <v-flex xs6>
                                <v-btn text
                                       :disabled="!!editcontact"
                                       :loading="adding"
                                       @click.stop="groupsdialog = true;
                                           singleselectedcontact.push(contactinfo)">
                                    Add to Group<v-icon>{{$store.state.icons.group}}</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 v-if="activecontact.groups">
                                <v-chip v-for="(d) in activecontact.groups"
                                        min-width="200"
                                        :key="d.uuid"
                                        class="ma-2"
                                        :close="editcontactgroups"
                                        @click:close="removeFromGroup(d.uuid,activecontact.sortkey)"
                                        :color="$store.state.color1"
                                        text-color="white" small
                                >
                                    {{d.name}}
                                </v-chip>
                            </v-flex>
                            <v-flex xs12 v-else>
                                <v-skeleton-loader
                                        class="mx-auto"
                                        type="card"
                                ></v-skeleton-loader>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <BaseBtn text @click="getActivity(contactinfo.uuid)" :loading="loading">Activity</BaseBtn>
                <v-spacer></v-spacer>
                <InvoicesByCustomerUuid v-if="activecontact" :uuid="activecontact.info.uuid" />
            </v-card-actions>

            <!--Add to Group Dialog -->
            <v-dialog
                    v-model="groupsdialog"
                    hide-overlay
                    scrollable
                    max-width="500px">
                <v-card>
                    <v-card-title>
                        Add to group:
                        <v-spacer></v-spacer>
                        <v-btn icon  @click.native="groupsdialog=false, editcontactgroups=false">
                            <v-icon>{{$store.state.icons.close}}</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <GroupList :callback="addToGroup" :icon="icons.plus" groups="groups"  />
                    </v-card-text>
                    <v-card-actions>
                        <BaseBtn text @click.native="groupsdialog=false, editcontactgroups=false">Cancel</BaseBtn>
                        <v-spacer></v-spacer>
                        <NewGroup />
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="activitydialog" scrollable persistant>
                <v-card v-if="activity">
                    <v-card-title>
                        {{activity.ct}} Interactions
                    </v-card-title>
                    <v-card-text>
                        <ContactActivity :data="activity.data" />
                    </v-card-text>
                    <v-card-actions>
                        <BaseBtn @click="activitydialog=false,activity=undefined"><v-icon>{{icons.close}}</v-icon></BaseBtn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog
                    v-model="pleaseaddnamedialog"
                    hide-overlay
                    scrollable
                    max-width="300px">
                <v-card>
                    <v-card-title>
                        <v-icon class="mr-2">{{icons.warning}}</v-icon>
                        Missing Data
                    </v-card-title>
                    <v-card-text>
                        <p class="subtitle-1">
                            Please add at least a name, cell or email..
                        </p>
                    </v-card-text>
                    <v-card-actions>
                        <BaseBtn  @click.native="pleaseaddnamedialog=false">OK</BaseBtn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-card>
        <div v-else class="text-center">
            <v-icon large>mdi-loading mdi-spin</v-icon>
        </div>
</template>

<script>
  //TODO update contact name in group
  import {
    mapState,
    mapActions,
    mapMutations,
    // mapGetters
  } from 'vuex'
  import BaseBtn from "../BaseBtn"
  import NewGroup from "../groups/NewGroup"
  import GroupList from "../groups/GroupList"
  import isEqual from 'lodash/isEqual'
  import CardCloser from "../CardCloser";
  import InvoicesByCustomerUuid from "../../views/invoicing/InvoicesByCustomerUuid";
  export default {
    props:['uuid'],
    components: {
      InvoicesByCustomerUuid,
      CardCloser, ContactActivity:()=>import("../lists/ContactActivity"), GroupList, NewGroup, BaseBtn},
    name: "ContactEditor",
    data:()=>{
      return {
        loading:false,
        removing:false,
        adding:false,
        contactdialog:false,
        contactinfo:{},
        contact_unchanged: {},
        valid:undefined,
        selectedcontacts: [],
        singleselectedcontact: [],
        groupsdialog:false,//false,
        editcontactgroups:false,
        dirty:false,
        key:'00000',
        activitydialog:false,
        activity:undefined,
        pleaseaddnamedialog:false,
        status:false,
        statusloading:false,
        contactstatus:['active','archived']
      }
    },
    mounted() {
      Object.keys(this.$store.state.contactinfoschema).forEach(k=>{
        if(this.activecontact && this.activecontact.info[k]){
          this.contactinfo[k] = this.activecontact.info[k]
        } else {
          this.contactinfo[k] = undefined
        }
      })
    },
    computed:{
      ...mapState(['icons','editcontact','activecontact','contacts','dev']),
    },
    watch:{
      contacts(n,o){
        let s = n.filter(f=>{return f.uuid===this.uuid})[0]
        if(!s)return;
        this.setActiveContact({info:s})
        this.cancelSave()
      },
      uuid(n,o){
        if(!this.activecontact){
          this.getActiveContact(this.uuid)
        }
      },
      activecontact(n,o){
        console.log(n,o)
        if(!n)return
        //this.contactinfo = JSON.parse( JSON.stringify(this.activecontact.info))
        //info will set the 'dirty edit' record, ie 'reset'
        Object.keys(this.$store.state.contactinfoschema).forEach(k=>{
          console.log(k)
          if(this.activecontact.info[k]){
            this.contactinfo[k] = this.activecontact.info[k]
          } else {
            this.contactinfo[k] = undefined
          }
        })
        console.log(this.activecontact.info)
        //this.contactinfo = JSON.parse(JSON.stringify(n.info))
        //this.status = n.status;
        if(n.info.status==='new'||o.info.status==='new'){
          this.contactinfo.status='active'
          this.saveContact()
        }
      }
    },
    methods: {
      ...mapActions(['post','get','getActiveContact']),
      ...mapMutations(['setEditContact','appendContact','removeContact', 'setActiveContact']),
      //CALLS THE CREATE OR SAVE CONTACT METHOD
      async refreshContact(){
        this.getActiveContact(this.contactinfo.uuid)
        Object.assign(this.contact_unchanged,this.activecontact.info);
      },
      closeContact: function(){
        this.setActiveContact(false)
        this.$router.go(-1)
        this.loading=false;
        this.setEditContact(false)
        this.singleselectedcontact=[];
      },
      setEdit(){
        this.setEditContact(true)
      },
      cancelSave(){
        this.setEditContact(false)
        this.contactinfo = JSON.parse(JSON.stringify(this.activecontact.info))
        this.status = this.contactinfo.status
        this.getActiveContact(this.uuid)
        this.key = new Date().getTime();
      },
      addToGroup: async function(group) {
        this.adding=true;
        //  if its only one contact, in the single selected, then its a call from the contact dialog. we ignore
        //  any other slectedcontacts for this call. else, its a normal multiselect
        //  singleselctedcontact is set in the @click event on the ADD To GROUP button!!! DO NOT CHANGE
        let c = (this.singleselectedcontact.length===1)?this.singleselectedcontact:this.selectedcontacts
        let body = {
          contacts: c,
          groupkey: group.groupkey,
          groupname: group.name,
          name: group.name,
          orgkey: this.$store.state.org.partkey
        }
        let res = await this.post({path:'api/groups/addtogroupv3',body:body})
        this.adding = false
        this.groupsdialog = false
        if(this.singleselectedcontact.length===1){
          this.$store.dispatch('getActiveContact',this.contactinfo.uuid);
          this.singleselectedcontact = []
        } else {
          this.selectedcontacts=[]
        }
        this.$store.commit('setSnackbar',{
          type: 'success',
          msg: res.msg,
          timeout:6000
        })
      },
      removeFromGroup: async function(d,c){
        this.removing=true;
        let data = {
          groupkey:d,
          contactuuid:c
        }
        await this.$store.dispatch('removeFromGroup',data);
        this.editcontactgroups = false;
        this.$store.dispatch('getActiveContact',this.contactinfo.uuid);
        this.removing=false
      },
      setChange(){
        let a = this.activecontact.info
        let b = this.contactinfo
        let s = isEqual(a,b)
        this.dirty = !s
      },
      async saveContact() {
        console.log('SAVEING',this.contactinfo)
        let em = this
        let body = {
          'uuid': em.contactinfo.uuid || null,
          'name': em.contactinfo.name || null,
          'cell': em.contactinfo.cell || null,
          'email': em.contactinfo.email || null,
          'nickname': em.contactinfo.nickname || null,
          'instagram': em.contactinfo.instagram || null,
          'orgtkey' : em.$store.state.org.partkey,
          'id': em.contactinfo.id || null,
          'status': em.contactinfo.status
        }
        //if (this.$refs.form.validate()) {
        if(!em.contactinfo.name && !em.contactinfo.cell && !em.contactinfo.email){
          em.pleaseaddnamedialog = true
          return;
        }
        em.loading=true;
        this.setEditContact(false)//handles edit vs readonly state
        let res = await this.post({path:'api/contacts/editcontactv3',body:body})
        this.loading=false;
        if(em.contactinfo.status==='archived'){
          this.removeContact({uuid:em.contactinfo.uuid})
          this.closeContact()
        } else {
          this.appendContact(em.contactinfo)
          this.setActiveContact(res)
        }
        if(!res.error){
          this.$store.commit('setSnackbar',{
            type: 'success',
            msg: body.name + ' - Saved',
            timeout:3000
          })
        }
        //}
      },
      async getActivity(uuid){
        this.loading=true
        let res = await this.get({path:'api/contacts/activityv2/'+uuid})
        this.loading=false
        this.activity={
          ct:res.ct,
          data:res.data
        }
        this.activitydialog = true
      }
    }
  }
</script>

<style scoped>

</style>